export default "__VITE_ASSET__C$I_tsJm__"